<template>
  <div>

    <div  >
      <div class="sm:overflow-hidden">
        <div class="bg-white space-y-6">
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">Общая информация</h3>
            <p class="mt-1 text-sm text-gray-500">
              Укажите название мероприятия, даты проведения и прочую информацию. Мероприятие не будет отображаться на
              сайте до тех пор, кока вы не активируете его на странице мероприятий.
            </p>
          </div>

          <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
            <ui-button>Сохранить</ui-button>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>

import UiButton from "@/components/ui/button/UiButton";

export default {
  name: "EventEditResult",
  components: {  UiButton,},
  data() {
    return {
      form: {
        name: '',
        date_start_reg: null,
        date_end: null,
      }
    }
  }
}
</script>

<style scoped>

</style>